import firebase from 'firebase/compat/app';

import { requireApiUrl } from '../config/runtimeConfig';

class FeedbacksServices {
  init = async function() {
    this.apiUrl = `${requireApiUrl()}/fb`;
  }

  putFeedback = async function(text) {
    const partUrl = `/feedback`;
    const authHeaders = { mode: 'cors', headers: {
        'Authorization': 'Bearer ' + await firebase.auth().currentUser.getIdToken(),
        'Content-Type': 'application/json'
      }
    };
    return fetch(this.apiUrl + partUrl, { ...authHeaders,
      method: 'POST',
      body: JSON.stringify({ text: text })
    });
  }
};

export default FeedbacksServices;